import { ExperimentName, IDevelopmentSettings, IInitParams } from "./IInitParams";

/**
 * Poskytuje konfigurační nastavení aplikace
 * @includeToDoc
 */
export interface IAppConfiguration extends Readonly<IInitParams> {
    /**
     * Výchozí způsob srovnání řetězců v našeptávači LOV. Hodnota je ve formě řetězce používané ve struktuře filtrů.
     */
    readonly defaultWhisperer: string;
    /**
     * Výchozí způsob srovnání řetězců ve filtru. Hodnota je ve formě řetězce používané ve struktuře filtrů.
     */
    readonly defaultFilter: string;

    /**
     * Vrací hodnotu vlastnosti konfiguračního nastavení 'developmentMode' v initParams.
     * @param option Název vlastnosti, kterou chceme zjistit
     */
    getDevelopmentOption<K extends keyof IDevelopmentSettings>(option: K): Readonly<IDevelopmentSettings[K]> | null;
    /**
     * Zjistí, zda je předaná experimentální funkcionalita aktivována.
     * @see https://www.martinfowler.com/articles/feature-toggles.html Feature Toggles
     * @param experimentName Název funkcionality
     */
    isExperimentEnabled(experimentName: ExperimentName): boolean;
}
